import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { captureAttributionFromUrl } from "../lib/attribution";
import { initAttribution } from "../lib/tracking";

export default function WelcomePage() {
  const navigate = useNavigate();

  // Capture UTM + seg from the ad landing URL on first paint. Stored in
  // sessionStorage and re-emitted on /complete so the worker can stamp
  // the registry row with the original campaign + GLP-1 cohort hint.
  useEffect(() => {
    captureAttributionFromUrl();
    initAttribution("vesper5-us");
  }, []);

  return (
    <div className="space-y-8">
      <div className="text-center space-y-4">
        <h1 className="text-[28px] font-extralight text-gray-900" style={{ letterSpacing: "-0.6px" }}>
          See if you may qualify for a research study
        </h1>
        <p className="text-[15px] text-gray-600 leading-relaxed">
          We are enrolling adults with obesity and Type 2 Diabetes for a clinical research study.
        </p>
      </div>

      <div className="bg-white rounded-2xl p-6 space-y-4" style={{ boxShadow: "0 1px 3px rgba(0,0,0,0.06)" }}>
        <h2 className="text-[13px] font-semibold text-gray-900 uppercase tracking-wider">
          What to expect
        </h2>
        <ul className="space-y-3 text-[14px] text-gray-600">
          <li className="flex items-start gap-3">
            <span className="w-5 h-5 rounded-full bg-[var(--color-leap21-brand-light)] text-[var(--color-leap21-brand)] flex items-center justify-center text-[11px] font-bold shrink-0 mt-0.5">1</span>
            <span>Answer a few health survey questions (about 3 minutes)</span>
          </li>
          <li className="flex items-start gap-3">
            <span className="w-5 h-5 rounded-full bg-[var(--color-leap21-brand-light)] text-[var(--color-leap21-brand)] flex items-center justify-center text-[11px] font-bold shrink-0 mt-0.5">2</span>
            <span>Review and consent to being part of the registry</span>
          </li>
          <li className="flex items-start gap-3">
            <span className="w-5 h-5 rounded-full bg-[var(--color-leap21-brand-light)] text-[var(--color-leap21-brand)] flex items-center justify-center text-[11px] font-bold shrink-0 mt-0.5">3</span>
            <span>If you may qualify, we will connect you with a study site near you</span>
          </li>
        </ul>
      </div>

      <div className="bg-[var(--color-status-caution-bg)] rounded-xl p-4 text-[13px] text-[var(--color-status-caution-text)]">
        <strong>Important:</strong> This is an investigational research study. There is no promise of benefit.
      </div>

      <button
        onClick={() => navigate("/start")}
        className="w-full py-3 rounded-xl bg-gray-900 text-white text-[14px] font-medium hover:bg-gray-800 active:scale-[0.97] transition-all"
      >
        Get Started
      </button>

      <p className="text-center text-[12px] text-gray-500">
        Your information is secure and encrypted.
      </p>
    </div>
  );
}
